<template>
    <div id="chart2" style="height: 35vh; width: 100%"></div>
</template>
  
<script>
import * as echarts from "echarts/core";
import { TooltipComponent, GridComponent } from "echarts/components";
import { LineChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GridComponent, TooltipComponent, LineChart, CanvasRenderer]);

export default {
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        list: {
            handler() {
                this.setChart();
            },
            deep: true,
        },
    },
    mounted() {
        var chartDom = document.getElementById("chart2");
        this.chart = echarts.init(chartDom);
        this.setChart();
    },

    beforeDestroy() {
        this.chart?.dispose();
    },
    methods: {
        setChart() {

            if (this.list.length === 0) return;

            let option = {
                color: ["#FFA700", "#3AA1FF"],
                tooltip: {
                    trigger: "item",
                },
                grid: {
                    top: "10%",
                    left: "10%",
                    right: "3%",
                    bottom: "15%",
                },
                xAxis: {
                    type: "category",
                    splitLine: {
                        show: true,
                    },
                    axisLabel: {
                        color: "#999",
                    },
                    data: this.list.map((item) => item.month),
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: "数量",
                        type: "line",
                        data: this.list.map((item) => item.number),
                    }
                ],
            };

            option && this.chart.setOption(option);
        }
    }
};
</script>